<template>
  <div style="display: flex;justify-content: center;">
    <img src="../static/banner-none.png">
  </div>
</template>

<script>
export default {
  name: "isBuilding"
}
</script>

<style scoped>

</style>
